import { useContext } from "react";
import { FleetListContext } from "../context";

export const useFleetList = () => useContext(FleetListContext);
